import script from "./CarModelSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarModelSearch.vue?vue&type=script&lang=ts&setup=true"

import "./CarModelSearch.vue?vue&type=style&index=0&id=c45c986c&lang=scss"

const __exports__ = script;

export default __exports__